/**
 * Tabular figures: four-place and eight-place decimals in neighbouring columns
 * only read as columns when the digits line up.
 */
export const NUMERIC_STYLE = { fontVariantNumeric: 'tabular-nums' } as const;
